import { createSelector } from "reselect";
import { initialState } from "./reducer";

const reducerState = (state) => state.Dashboard || initialState;

const makeDashboardSelectField = (field) =>
  createSelector(reducerState, (dashboardState) => dashboardState[field]);

export { reducerState, makeDashboardSelectField };
